import { render, staticRenderFns } from "./ModalAdminAffiliate.vue?vue&type=template&id=67273c7a&scoped=true"
import script from "./ModalAdminAffiliate.vue?vue&type=script&lang=js"
export * from "./ModalAdminAffiliate.vue?vue&type=script&lang=js"
import style0 from "./ModalAdminAffiliate.vue?vue&type=style&index=0&id=67273c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67273c7a",
  null
  
)

export default component.exports